import { Box, Typography } from '@mui/material';
import React from 'react';
import { COLORS } from '../../constants/constants';
import { i18n } from '../../i18n/i18n';
import { Tooltip } from '@cellebrite/saas-ui-common';

interface FilterChipProps {
    label: string;
    value: string;
}

const FilterInfo: React.FC<FilterChipProps> = ({ label, value }) => {
    return (
        <Tooltip
            content={<Typography className="color-bd">{i18n.translate('Filtered by advanced search')}</Typography>}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 2,
                    py: 1,
                    backgroundColor: COLORS.BRAND_LIGHTEST,
                    borderRadius: '8px',
                }}
            >
                <Typography sx={{ color: COLORS.BRAND_DARK }} variant="s16w500" noWrap>{`${label}:`}</Typography>
                <Typography sx={{ color: COLORS.BRAND, ml: 1 }} variant="s16w500" noWrap>
                    {value}
                </Typography>
            </Box>
        </Tooltip>
    );
};

export default FilterInfo;
